import fpApiUtil from "./fp-api-util";
import axiosUtil from "@plannel/utils/axios-bigint";

const BASE = "factoryplan/simulation/simulation-step/step-seqs";

// 절차 상세(계획 단계별 실행 항목) 조회 — params: { planScope, stepCd }.
// SimulationController POST simulation-step/step-seqs → planningService.getPlanStepSeqs.
const getAll = (params) => fpApiUtil.postParams(BASE, params);

// 절차 헤더(tb_fp_plan_step)와 상세(tb_fp_plan_step_seq)를 한 번에 저장.
// SimulationController.savePlanStepAndSeqs는 changes(=Map<String,String>)와 plan-scope를
// **별도 form 필드**로 읽는다 — changes 안의 update/create/delete는 각각 **JSON 문자열**이어야 한다
// (배열 그대로 보내면 Map<String,String> 역직렬화에서 실패). plan-scope는
// cmPlanScopeService.isExample(...) 판정과 헤더 upsert에 쓰인다.
// 행의 id는 axios-bigint가 네이티브 BigInt로 파싱해두므로 순수 JSON.stringify는 TypeError가 난다 —
// 반드시 BigInt-safe 직렬화를 쓴다.
// stepCd가 비어 있으면 서버가 `FP_STEP_<yyyyMMddHHmmss>`를 채번하고 data.newPlanStepCd로 돌려준다.
const save = ({ planScope, stepCd, stepNm, update, create, remove }) =>
  fpApiUtil.postFields(`${BASE}/save`, {
    changes: {
      update: axiosUtil.jsonbigStringfy(update ?? []),
      create: axiosUtil.jsonbigStringfy(create ?? []),
      delete: axiosUtil.jsonbigStringfy(remove ?? []),
      stepCd: stepCd ?? null,
      stepNm: stepNm ?? ""
    },
    "plan-scope": planScope
  });

const fpSimulationStepService = { getAll, save };
export default fpSimulationStepService;
